import { DownloadHistory, State } from './model';
import { IHistoricalDefault } from '../../historical';

export const DownloadHistoryDefault: DownloadHistory = IHistoricalDefault();

export const StateDefault: State = {
  historical: {...DownloadHistoryDefault}
};

export default StateDefault;
